import { createStyles } from '@mui/material'

const styles = () =>
  createStyles({
    root: {
      width: '100%',
      overflowX: 'auto',
    },
    table: {
      tableLayout: 'fixed',
    },
  })

export default styles
